<template>
  <div class="pcg-whitelist d-flex text-center">
    <div class="mx-auto mt-5 pt-5" v-if="twitch_role === 'broadcaster' && acceptedTos">
      <p style="width: 75%;margin:auto;margin-top: -60px;">{{ translation.general.chooseChatBotLanguage }}</p>
      <div class="mb-4 mt-4">
        <img src="./img/unown.gif" alt="unown" width="80">
      </div>
      <div>

        <div
            v-for="lang in [['en', 'English'], ['de','German'], ['pt','Portuguese'], ['fr','French'], ['es', 'Spanish']]"
            :key="lang">

          <button style="width: 60%;margin:3px;" @click="onLanguageButtonClicked(lang[0])">{{ lang[1] }}</button>

        </div>

      </div>

      <button @click="refreshIfStreamerStarted()" :disabled="isBlocked"
              class="btn btn-link poketwitch__header-btn--refresh pcg-whitelist-refresh">
        <svg class="bi bi-arrow-clockwise" width="50px" height="50px" viewBox="0 0 16 16" fill="currentColor"
             xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd"
                d="M3.17 6.706a5 5 0 0 1 7.103-3.16.5.5 0 1 0 .454-.892A6 6 0 1 0 13.455 5.5a.5.5 0 0 0-.91.417 5 5 0 1 1-9.375.789z"/>
          <path fill-rule="evenodd"
                d="M8.147.146a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 1 1-.707-.708L10.293 3 8.147.854a.5.5 0 0 1 0-.708z"/>
        </svg>
      </button>

    </div>

    <div class="mx-auto mt-5 pt-5" v-else-if="twitch_role === 'broadcaster' && !acceptedTos">
      <p style="width: 75%;margin:auto;margin-top: -60px;">Rules:</p>

      - 24/7 Streams are forbidden <br>
      - AFK Streams are forbidden (sleeping / stepping away from the computer for a longer period of time)<br>


      <div class="mb-4 mt-4">
        <img src="./img/unown.gif" alt="unown" width="80">
      </div>
      <div>
        <br>
        <input type="checkbox" @click="readRules=!readRules">
        <br>
        I've read and accept the rules
        <br>
        <br>
        <button @click="acceptedTos=true;" :disabled="!readRules">Accept</button>

      </div>


    </div>

    <div v-else class="mx-auto mt-5 pt-5">
      The streamer didn't setup the extension

      <br>
      <br>
      <br>

      <div>
        <div class="mb-4 mt-4">
          <img src="./img/unown.gif" alt="unown" width="80">
        </div>

        <button @click="refreshIfStreamerStarted()" :disabled="isBlocked"
                class="btn btn-link poketwitch__header-btn--refresh pcg-whitelist-refresh">
          <svg class="bi bi-arrow-clockwise" width="50px" height="50px" viewBox="0 0 16 16" fill="currentColor"
               xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
                  d="M3.17 6.706a5 5 0 0 1 7.103-3.16.5.5 0 1 0 .454-.892A6 6 0 1 0 13.455 5.5a.5.5 0 0 0-.91.417 5 5 0 1 1-9.375.789z"/>
            <path fill-rule="evenodd"
                  d="M8.147.146a.5.5 0 0 1 .707 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 1 1-.707-.708L10.293 3 8.147.854a.5.5 0 0 1 0-.708z"/>
          </svg>
        </button>

      </div>
    </div>


  </div>
</template>

<script>
import {translation} from "@/utils/translations";
import {blockButton, isBlocked, unblockButton} from "@/components/ButtonControl/ButtonControl";
import {currentView} from "@/utils/globals";
import {backendUri, firstView} from "@/utils/settings";
import {showModalMsg} from "@/components/Modal/modalUtils";
import axios from "axios";
import {startLoadingProcess, stopLoadingProcess} from "../../../components/LoadingOverlay/loadingOverlayControl";
import {twitch_role} from "../../../utils/globals";
import {ref} from "@vue/reactivity";

export default {
  name: "NotWhitelisted",
  setup() {

    const readRules = ref(false);
    const acceptedTos = ref(false);

    const onLanguageButtonClicked = async (lang) => {
      console.log(lang);
      startLoadingProcess();
      await axios.get(backendUri + "api/game/ext/add-chatbot/?lang=" + lang)
          .then(() => {
            stopLoadingProcess();
            currentView.value = firstView;
          })
          .catch(() => {
            showModalMsg(translation.general.notWhitelistedDiscord);
          })


    }

    const refreshIfStreamerStarted = async () => {
      blockButton();
      setTimeout(function () {
        unblockButton();
      }, 6000);

      await axios.get(backendUri + "api/game/ext/ping/")
          .then(() => {
            currentView.value = firstView;
          })
          .catch(() => {
            showModalMsg(translation.general.notWhitelistedDiscord);
          })
    }

    return {
      translation,
      refreshIfStreamerStarted,
      isBlocked,
      onLanguageButtonClicked,
      twitch_role,
      acceptedTos,
      readRules
    }
  }
}

</script>

<style scoped lang="scss">
@import '@/scss/variables';

.pcg-whitelist {
  &-refresh {
    color: white;
    width: 100px;
    height: 100px;
  }

  background-color: $poketwitch-branding-color;
  color: white;
  font-family: "Josefin Sans", sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;

  &__url {
    color: white;
    transition: all .3s;
    background: #9f3e3e;
    padding: 10px;
    border-radius: 3px;

    &:hover {
      background: #c62b2b;
      box-shadow: #c62b2b 0 0 10px;
      text-decoration: none;
    }
  }
}
</style>